import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from '../../../common';
import { RootState } from '../../../reducers';
import { selectCommonModelVersionId } from '../common/store/selectors';
import { AssociationsComponent } from './components/AssociationsComponent';
import { modelAssociationsSlice } from './store/slice';
import { selectDataFeeds } from 'src/store/userSettings';
import { ModelAssociationsActionTypes } from './store/thunks';

const actionTypes = [
  ModelAssociationsActionTypes.FetchModelAssociations, 
  ModelAssociationsActionTypes.FetchGetAfslAndPracticeDetailsForAdviser
];

const mapStateToProps = (state: RootState) => ({
  modelVersionId: selectCommonModelVersionId(state),
  dataFeeds: selectDataFeeds(state),
  loadingProgress: progressSelectorFactory(actionTypes)(state),
});

const mapDispatchToProps = {
  ...modelAssociationsSlice.actions,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;

export const ModelAssociationsStateContainer = connector(AssociationsComponent);
